module.exports = __webpack_public_path__ + "static/media/Ceat.094bc17d.png";